import { CONTACT_EMAIL, SITE_ORIGIN, SOCIAL_IMAGE_PATH, SOCIAL_LINKS } from '../data/navigation';

const SCHEMA_CONTEXT = 'https://schema.org';
const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
const COUNTRY = 'DE';

export interface ServiceSummary {
    name: string;
    description: string;
}

export interface FaqEntry {
    question: string;
    answer: string;
}

interface ServicesPageInput {
    language: string;
    url: string;
    catalogName: string;
    services: ServiceSummary[];
    faq: FaqEntry[];
}

function organization(language: string): object {
    return {
        '@context': SCHEMA_CONTEXT,
        '@type': 'ProfessionalService',
        '@id': ORGANIZATION_ID,
        name: 'Haukel GbR',
        alternateName: 'Haukel',
        url: SITE_ORIGIN,
        email: CONTACT_EMAIL,
        image: `${SITE_ORIGIN}${SOCIAL_IMAGE_PATH}`,
        foundingDate: '2024-01-01',
        founder: [
            { '@type': 'Person', name: 'Marc Hauck' },
            { '@type': 'Person', name: 'Jan Kellermann' }
        ],
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'Am Bärenbach 11',
            postalCode: '74541',
            addressLocality: 'Vellberg',
            addressRegion: 'Baden-Württemberg',
            addressCountry: COUNTRY
        },
        areaServed: { '@type': 'Country', name: 'Germany' },
        knowsLanguage: language,
        sameAs: SOCIAL_LINKS.map((link) => link.href)
    };
}

export function servicesPageStructuredData({ language, url, catalogName, services, faq }: ServicesPageInput): object[] {
    return [
        {
            ...organization(language),
            hasOfferCatalog: {
                '@type': 'OfferCatalog',
                name: catalogName,
                itemListElement: services.map((service) => ({
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: service.name,
                        description: service.description,
                        provider: { '@id': ORGANIZATION_ID },
                        areaServed: COUNTRY,
                        url
                    }
                }))
            }
        },
        {
            '@context': SCHEMA_CONTEXT,
            '@type': 'FAQPage',
            inLanguage: language,
            mainEntity: faq.map((entry) => ({
                '@type': 'Question',
                name: entry.question,
                acceptedAnswer: { '@type': 'Answer', text: entry.answer }
            }))
        }
    ];
}

/**
 * JSON-LD lives inside a script element, so a literal "<" must not be able to close it.
 */
export function serializeStructuredData(structuredData: object[]): string {
    return JSON.stringify(structuredData).replace(/</g, '\\u003c');
}
